// #region Imports
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from '~HOC';
import Pagination from 'react-js-pagination';
import { injectIntl, FormattedMessage } from 'react-intl';
import { changeLanguage } from '../../../../actions/language';
import momentjs from 'moment-jalaali';
import { validateForm, validation } from '../../../../utils/validation';
import { usersApi, employeeAllocationApi } from '../../../../services/apis';
import { numberWithCommas } from '../../../../utils/consts';
import { returnMiladiDateByStandardFormat } from '../../../../utils/utility';
import EmployeeCreditAllocation from '../../../../domain/profile/employeeCreditAllocation/employeeCreditAllocation';
import { ChevronDownIcon } from '~svg';
import {
  Button,
  MobileFlightInfoBooking,
  Modal,
  Input,
  DatePicker,
  ValidationMessage,
} from '../../../../component';
// #endregion

class MobileAdminCredit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      passengerLst: [],
      creditexpensesList: [],
      data: {
        startDate: '',
        endDate: '',
        phrase: '',
      },
      employeeActivePage: 1,
      employeeItemPerPage: 3,
      profileId: 0,
      itemPerPage: 10,
      pageNumber: 1,
      detailPageNumber: 1,
      flights: [],
      creditList: [],
      errors: {},
    };
  }
  //#region APIs
  //get all employees by business profile Id
  getAllEmployee = (employeeActivePage = 1) => {
    try {
      usersApi
        .employeeListByProfileId({
          profileId,
          pageNumber: employeeActivePage,
          itemPerPage: employeeItemPerPage,
          data: { phrase: '', departmentId: 0 },
        })
        .then((res) => {
          this.setState({
            employeeList: res.payload.data,
            totalEmployeeRecords: parseInt(res.payload.totalRecords),
            employeeActivePage,
          });
        })
        .catch((error) => console.log(error));
    } catch (error) {
      console.log(error);
    }
    const { profileId, employeeItemPerPage } = this.state;
  };
  //fetch All credit expenses by creditId
  fetchCreditExpenses = (creditId) => {
    try {
      let { detailPageNumber, itemPerPage } = this.state;
      employeeAllocationApi
        .getAllExpansessbyCreditId({
          creditId,
          pageNumber: detailPageNumber,
          itemPerPage,
        })
        .then((expensesList) => {
          this.setState(
            {
              creditexpensesList: expensesList.payload.data.rows,
              expensesListTotalCount: expensesList.payload.totalRecords,
            },
            () => {},
          );
        })
        .catch((error) => console.log(error));
    } catch (error) {
      console.log(error);
    }
    let { detailPageNumber, itemPerPage } = this.state;
    employeeAllocationApi
      .getAllExpansessbyCreditId({
        creditId,
        pageNumber: detailPageNumber,
        itemPerPage,
      })
      .then((expensesList) => {
        this.setState(
          {
            creditexpensesList: expensesList.payload.data.rows,
            expensesListTotalCount: expensesList.payload.totalRecords,
          },
          () => {},
        );
      })
      .catch();
  };
  /* Fetch All Credits by EmpId and profileId */
  fetchAllCredits = () => {
    try {
      let { pageNumber, itemPerPage } = this.state;
      employeeAllocationApi
        .getAllProfileAllocation({
          pageNumber,
          itemPerPage,
        })
        .then((results) => {
          this.setState({
            creditList: results.payload.data.rows,
            creditListTotalCount: results.payload.totalRecords,
          });
        })
        .catch((error) => console.log(error));
    } catch (error) {}
  };
  // #region life sycle components
  componentDidMount() {
    //set scroll in top of screen
    document.addEventListener('DOMContentLoaded', () => {
      window.scroll({
        top: 0,
        behavior: 'smooth',
      });
    });

    const parsedQueryStr = Object.fromEntries(
      new URLSearchParams(this.props?.location?.search),
    ); //If id exists in query string then fetch data
    if (parsedQueryStr && parsedQueryStr.id)
      this.setState({ profileId: parseInt(parsedQueryStr.id) }, () => {
        this.fetchAllCredits();
        this.getAllEmployee();
      });
  }
  // #endregion
  // Set validations for fields
  // schema = {
  //   startDate: this.validationTypes.optional,
  //   endDate: this.validationTypes.optional,
  //   phrase: this.validationTypes.optional,
  // };
  //#region  Functions

  returnResult = () => {
    this.setState({ profileId: '', employeeId: '', showModal: false }, () => {
      this.fetchAllCredits();
    });
  };
  //Function To Show details for each main Credit record
  setCreditFlag = (index, item) => {
    let creditList = [...this.state.creditList];
    creditList.map((item, ind) => {
      if (index != ind) {
        creditList[ind].showDetail = false;
        creditList[ind].flag = false;
      }
    });
    creditList[index].showDetail = !item.showDetail;
    creditList[index].flag = !item.flag;
    this.setState(
      { creditList, detailPageNumber: 1, expensesListTotalCount: 0 },
      () => {
        this.fetchCreditExpenses(item.id);
      },
    );
  };
  setEmployee = (emp) => {
    this.setState({ selectedEmp: emp.userId, showModal: true });
  };
  /* Change Employee Page number */
  employeePageChange = (employeeActivePage) => {
    this.setState({ employeeActivePage }, () =>
      this.getAllEmployee(employeeActivePage),
    );
  };
  doSubmit = () => {
    this.setState({ pageNumber: 1 }, () => {
      this.fetchAllCredits();
    });
  };
  //Change detail Page number
  detailPageChange = (pageNumber, creditId) => {
    this.setState({ detailPageNumber: pageNumber }, () => {
      this.fetchCreditExpenses(creditId);
    });
  };
  //Change Page number
  pageChange = (pageNumber) => {
    this.setState({ pageNumber: pageNumber }, () => {
      this.fetchAllCredits();
    });
  };
  //#endregion
  //#region Renders
  //Render Main record For Profile credits
  renderMainCredit(item, index) {
    let centerClass = 'justify-content-center align-items-center';
    return (
      <div
        key={`mainCredit-${item.id}`}
        className="d-flex w-100 flex-column glass-flight mt-2 "
      >
        <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center">
          {this.renderColumn(
            'booking.fullname',
            `${item.profile && item.profile.firstName} ${
              item.profile && item.profile.lastName
            }`,
            true,
            ` ${centerClass}`,
          )}
        </div>
        <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center">
          {this.renderColumn(
            'profilecredit.creditamount',
            `${item.amount} ${item.currency.moneyUnit}`,
            true,
            ` ${centerClass}`,
          )}
          {this.renderColumn(
            'profilecredit.expensesamount',
            `${item.amount - item.remainAmount} ${item.currency.moneyUnit}`,
            true,
            ` ${centerClass}`,
          )}
        </div>
        <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center">
          {this.renderColumn(
            'profilecredit.remaincreditamount',
            `${item.remainAmount} ${item.currency.moneyUnit}`,
            true,
            ` ${centerClass}`,
          )}
          {this.renderColumn(
            'profilecredit.assigndate',
            item && item.createdAt && this.props.language.direction === 'ltr'
              ? new Date(item.createdAt).toISOString().split('T')[0]
              : `${momentjs(item.createdAt, 'YYYY-M-D').format(
                  'jYYYY-jMM-jDD',
                )} `,
            false,
            ` ${centerClass}`,
          )}
        </div>
        <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center">
          {this.renderColumn(
            'profilecredit.duration',
            item.period,
            true,
            `${centerClass}`,
          )}

          {this.renderColumn(
            'profilecredit.creditstatus',
            item.employeeAllocationStatus.name[this.props.language.name],
            false,
            ` ${centerClass}`,
          )}
        </div>
        <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center cursor-pointer">
          {item.hasExpenses &&
            this.renderDetailIcon('credits', index, item, 'booking.details')}
        </div>
        {this.state.creditexpensesList &&
          this.state.creditexpensesList.length > 0 &&
          this.state.creditexpensesList.map((expense, index) =>
            this.renderDetails(expense, item.showDetail, index),
          )}
        {this.state.creditList[index].showDetail === true &&
          this.state.expensesListTotalCount > 0 &&
          this.renderDetailPaging(this.state.expensesListTotalCount, item.id)}
      </div>
    );
  }

  //Render paging
  renderPaging = (totalCount) => {
    let { pageNumber, itemPerPage } = this.state;
    if (totalCount > 0)
      return (
        <div className="W-100 d-flex p-0 justify-content-center align-items-center">
          <Pagination
            pageRangeDisplayed={5}
            linkClass="page-link"
            itemClass="page-item"
            innerClass="pagination py-2 directionInitial"
            activeClass="active"
            activePage={pageNumber}
            itemsCountPerPage={itemPerPage}
            totalItemsCount={totalCount}
            onChange={(fun) => this.pageChange(fun)}
          />
        </div>
      );
  };
  //Render detail paging
  renderDetailPaging = (totalCount, creditId) => {
    let { detailPageNumber, itemPerPage } = this.state;
    if (totalCount > 0)
      return (
        <div className="W-100 d-flex p-0 justify-content-center align-items-center">
          <Pagination
            pageRangeDisplayed={5}
            linkClass="page-link"
            itemClass="page-item"
            innerClass="pagination py-2 directionInitial"
            activeClass="active"
            activePage={detailPageNumber}
            itemsCountPerPage={itemPerPage}
            totalItemsCount={totalCount}
            onChange={(fun) => this.detailPageChange(fun, creditId)}
          />
        </div>
      );
  };
  //render link to show previous passengers
  // renderPerviousPassengerslink = (passenger, id) => {
  //   return (
  //     <Modal
  //       title={
  //         <div
  //           className={`modal-header  pt-3  ${
  //           "bg-primary"
  //           }`}
  //         >
  //           <h5 className="modal-title text-center w-100 font-weight-bold text-white">
  //             <FormattedMessage id="booking.passengerinfo" />
  //           </h5>
  //         </div>
  //       }
  //       isOpen={this.state.showModal}
  //       onClose={() => this.setState({ showModal: false })}
  //     >
  //       <PassengerModal
  //         passengerLst={passenger}
  //         isMobile={true}
  //         // modalID={`PerviousPassengersModal-${_id}`}
  //       />
  //     </Modal>
  //   );
  // return (
  //   <div className="fade modal" id={`PerviousPassengersModal-${id}`}>
  //     <PassengerModal
  //       passengerLst={passenger}
  //       isMobile={true}
  //       modalID={`PerviousPassengersModal-${_id}`}
  //     />
  //   </div>
  // );
  // };
  // Show All Credits
  renderCreditList = () => {
    if (this.state.creditList.length > 0) {
      return this.state.creditList.map((item, index) =>
        this.renderMainCredit(item, index),
      );
    } else if (this.state.notExist) {
      return (
        <div className="col d-flex p-0 flex-column my-5">
          <div className="col-12 d-flex  justify-content-center align-items-center text-primary font-weight-bold h2">
            <FormattedMessage id="booking.noavailableflight" />
          </div>

          <div className="justify-content-center col-12 d-flex">
            <img
              src={require('../../../../content/images/icon/not-found.png')}
              alt=""
            />
          </div>
        </div>
      );
    }
  };

  //render Employee Allocation modal to Assign credit for selected Employee
  renderEmployeeAllocationModal = () => {
    return (
      <Modal
        onClose={this.setState({ showModal: false })}
        title={<FormattedMessage id="profilecredit.assigncredit" />}
        isOpen={this.state.showModal}
      >
        <EmployeeCreditAllocation
          showModal={true}
          profileId={this.state.profileId}
          employeeId={this.state.selectedEmp}
          returnResult={this.returnResult}
        />
      </Modal>
    );
    // return (
    //   <div className="modal-dialog" role="document">
    //     <div className="modal-content">
    //       <div
    //         className={`${
    //           this.props.language.direction == "ltr"
    //             ? ""
    //             : "justify-content-center"
    //         }  border-bottom p-3 bg-primary text-center text-white`}
    //       >
    //         <Button
    //           type="button"
    //           className="btn-secondary p-2"
    //           data-dismiss="modal"
    //           aria-label="Close"
    //           onClick={() => this.setState({ selectedEmp: "" })}
    //         ></Button>
    //         <h5
    //           className={`${
    //             this.props.language.direction == "ltr"
    //               ? ""
    //               : "d-flex justify-content-center p-0 col-11"
    //           }`}
    //         >
    //           <FormattedMessage id="profilecredit.assigncredit" />
    //         </h5>
    //       </div>
    //       <div
    //         className="modal-body  p-2 text-right w-100"
    //         style={{ color: "black" }}
    //       >
    //         <div>
    //           <EmployeeCreditAllocation
    //             showModal={true}
    //             profileId={this.state.profileId}
    //             employeeId={this.state.selectedEmp}
    //             returnResult={this.returnResult}
    //           />
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // );
  };

  //render Detail Icon
  renderDetailIcon = (type, index, item, title) => {
    return (
      <div
        className={`d-flex ${
          type === 'credits' ? '' : ' text-underline'
        } mb-3 border-0 text-uppercase bg-transparent text-white   ${
          this.props.language.direction === 'rtl' ? 'font-smaller' : 'font-tiny'
        } justify-content-center align-items-center font-weight-bold outline-none`}
        onClick={() =>
          type === 'credits'
            ? this.setCreditFlag(index, item)
            : this.setEmployee(item)
        }
        data-toggle={type === 'employee' ? 'modal' : ''}
        data-target={type === 'employee' ? '#employeeAllocationModal' : ''}
      >
        <div className="d-flex justify-content-center align-items-center font-weight-bold ">
          <FormattedMessage id={title} />
        </div>
        {type === 'credits' && (
          <div className="d-flex justify-content-center align-items-center px-1">
            <ChevronDownIcon color="#aaacaf" size={16} />
          </div>
        )}
      </div>
    );
  };
  // validations
  handleValidation = () => {
    const { error, result } = validateForm({
      phrase: validation.string(this.state.data.phrase).required().errors,
      startDate: validation.required().errors,
      endDate: validation.required().errors,
    });
    return { error, result };
  };
  // render handleChange
  handleChange = (event) => {
    const { currentTarget: input } = event;
    const data = { ...this.state.data };
    data[input.name] = input.value;
    this.setState({ data }, () => {
      this.setState({
        errors: {
          ...this.state.errors,
          [input.name]: this.handleValidation().error[input.name],
        },
      });
    });
  };
  //render Employee Allocation modal to Assign credit for selected Employee
  // renderEmployeeAllocationModal = () => {
  //   return (
  //     <div className="modal-dialog" role="document">
  //       <div className="modal-content">
  //         <div
  //           className={`${
  //             this.props.language.direction == "ltr"
  //               ? ""
  //               : "justify-content-center"
  //           }  border-bottom p-3 bg-primary text-center text-white`}
  //         >
  //           <Button
  //             type="button"
  //             className="btn-secondary p-2"
  //             data-dismiss="modal"
  //             aria-label="Close"
  //             onClick={() => this.setState({ selectedEmp: "" })}
  //           ></Button>
  //           <h5
  //             className={`${
  //               this.props.language.direction == "ltr"
  //                 ? ""
  //                 : "d-flex justify-content-center p-0 col-11"
  //             }`}
  //           >
  //             <FormattedMessage id="profilecredit.assigncredit" />
  //           </h5>
  //         </div>
  //         <div
  //           className="modal-body  p-2 text-right w-100"
  //           style={{ color: "black" }}
  //         >
  //           <div>
  //             <EmployeeCreditAllocation
  //               showModal={true}
  //               profileId={this.state.profileId}
  //               employeeId={this.state.selectedEmp}
  //               returnResult={this.returnResult}
  //             />
  //           </div>
  //         </div>
  //       </div>
  //     </div>
  //   );
  // };
  //Render Details for each record
  renderDetailsrenderDetails = (item, showDetail, index) => {
    if (showDetail) {
      let flightsLength =
          item.booking && item.booking.flights.itineraries
            ? item.booking.flights.itineraries.length
            : 0,
        totalPassenger =
          parseInt(item.booking.flights.adultCount) +
          parseInt(item.booking.flights.childCount) +
          parseInt(item.booking.flights.infantCount);

      return (
        <div
          className="border m-1 p-0 font-weight-bold text-left  cursor-pointer  mb-1"
          style={{
            borderRadius: '10px',
            border: '2px solid rgba(255, 255, 255, 0.18)',
          }}
        >
          <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center">
            {this.renderColumn(
              'booking.invoicenumber',
              item.booking.invoiceNo,
              false,
            )}
            {this.renderColumn(
              'booking.orderdate',
              this.props.language.direction === 'ltr'
                ? `${
                    item.booking.orderDate.split('T')[0]
                  } ${item.booking.orderDate.split('T')[1].substring(0, 5)}`
                : momentjs(
                    item.booking.orderDate.split('T')[0],
                    'YYYY-M-D',
                  ).format('jYYYY-jMM-jDD'),
              false,
            )}
          </div>
          <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center">
            {this.renderColumn(
              'booking.counter',
              `${item.booking.individualProfile.firstName} ${item.booking.individualProfile.lastName}`,
              false,
            )}
            {this.renderColumn(
              'profilecredit.expensesamount',
              `${Number(item.amount).toFixed(2)} ${item.currency.moneyUnit}`,
              true,
            )}
          </div>
          <MobileFlightInfoBooking
            index={index}
            flightLength={flightsLength}
            item={item.booking}
            totalPassenger={totalPassenger}
            //className="w-100"
            pageName="saleAccounting"
          />
        </div>
      );
    }
  };
  // render column For each record
  renderColumn = (message, value, isNumber, centerClass) => {
    return (
      <div
        className={`d-flex flex-column w-100 text-uppercase font-weight-bold text-third font-smaller px-1 ${centerClass} `}
      >
        <div className="w-100 text-center">
          <FormattedMessage id={message} />
        </div>

        <div className="w-100 text-uppercase font-smaller font-weight-bold text-white pt-2 justify-content-center d-flex">
          {isNumber ? numberWithCommas(value) : value}
        </div>
      </div>
    );
  };
  //render search panel for counter tab
  renderSearchPanle = () => {
    return (
      <div id="searchAccordion">
        <div className="card">
          <div className="card-header" id="headingOne">
            <h5
              className={`mb-0 text-primary cursor-pointer text-uppercase font-weight-bold font-smaller  ${
                this.props.language.direction === 'ltr' ? '' : 'text-right'
              }`}
              data-toggle="collapse"
              data-target="#searchCollapse"
              aria-expanded="true"
              aria-controls="searchCollapse"
            >
              <FormattedMessage id="booking.filter" />
              <span className="px-1">
                <ChevronDownIcon />
              </span>
            </h5>
          </div>
          <div
            id="searchCollapse"
            className="collapse"
            aria-labelledby="headingOne"
            data-parent="#searchAccordion"
          >
            <div className="card-body px-sm-3 px-0 py-1">
              <div className="d-flex w-100 flex-column px-2">
                <div className="w-100 d-flex  pt-2  input-advenced-filter">
                  {/* {this.renderInput("phrase", "booking.fullname")} */}
                  <Input
                    type={'text'}
                    name={`phrase`}
                    value={this.state.data.phrase}
                    label={'booking.fullname'}
                    themeMode="light"
                    outSideLabel={true}
                    outSideLabelPosition="top"
                    onChange={(event) => this.handleChange(event)}
                    className={``}
                    inputClassName={
                      'font-normal height-input-profile px-sm-3 px-3'
                    }
                    outSideLabelClass={`font-weight-bold font-xxl-normal font-xl-small font-lg-msmall font-smaller`}
                    iconUrl={null}
                  />
                  <ValidationMessage errors={this.state.errors['phrase']} />
                </div>
                <div className="d-flex w-100 font-smaller  pt-1">
                  {/* {this.renderDatePicker(
                    "counterStartDate",
                    "profilecredit.fromdate"
                  )} */}
                  <DatePicker
                    themeMode="light"
                    tabIndex="1"
                    placeholder="profilecredit.fromdate"
                    value={this.state.data.startDate}
                    error={this.state.errors['counterStartDate']}
                    className=""
                    outSideLabelClassname="dropDown-fontSize"
                    outSideLabel={true}
                    withoutShadow={true}
                    heightSize="height-55px px-lg-0 px-3"
                    onChange={(date) => {
                      this.handleChange({
                        currentTarget: {
                          value: returnMiladiDateByStandardFormat(date),
                          name: 'counterStartDate',
                        },
                      });
                    }}
                  />
                  <ValidationMessage errors={this.state.errors['startDate']} />
                </div>
                <div className="d-flex w-100 font-smaller  pt-1">
                  {/* {this.renderDatePicker(
                    "counterEndDate",
                    "profilecredit.todate"
                  )} */}
                  <DatePicker
                    themeMode="light"
                    tabIndex="2"
                    placeholder="profilecredit.counterEndDate"
                    value={this.state.data.endDate}
                    error={this.state.errors['counterEndDate']}
                    className=""
                    outSideLabelClassname="dropDown-fontSize"
                    outSideLabel={true}
                    withoutShadow={true}
                    heightSize="height-55px px-lg-0 px-3"
                    onChange={(date) => {
                      this.handleChange({
                        currentTarget: {
                          value: returnMiladiDateByStandardFormat(date),
                          name: 'counterEndDate',
                        },
                      });
                    }}
                  />
                  <ValidationMessage errors={this.state.errors['endDate']} />
                </div>
                <div className="d-flex  flex-row align-items-center justify-content-center">
                  <Button
                    id="mobile-admin-credit-submit"
                    name="mobile-admin-credit-submit"
                    className="btn-secondary py-3"
                    disabled={!this.handleValidation().result}
                    label={this.props.intl.formatMessage({
                      id: 'booking.search',
                    })}
                  ></Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  /* Render table for showing employees */
  showEmployeeList = () => {
    let centerClass = 'justify-content-center align-items-center';
    const { employeeList } = this.state;
    const { name } = this.props.language;

    if (employeeList && employeeList.length)
      return employeeList.map((emp, index) => (
        <>
          <div className="d-flex flex-column col p-0">
            <div
              key={`mainEmp-${emp.id}`}
              className="d-flex w-100 flex-column glass-flight mt-2 "
            >
              <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center">
                {this.renderColumn(
                  'profile.username',
                  emp.userName,
                  true,
                  ` ${centerClass}`,
                )}
              </div>
              <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center">
                {this.renderColumn(
                  'profile.fullname',
                  `${emp.firstName}  
              ${emp.lastName}`,
                  true,
                  ` ${centerClass}`,
                )}
                {this.renderColumn(
                  'department.department',
                  emp.departmentName
                    ? emp.departmentName?.[name === 'fa' ? 'fa' : 'en']
                    : '---',
                  true,
                  ` ${centerClass}`,
                )}
              </div>
              <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center">
                {this.renderColumn(
                  'profile.role',
                  emp.roleName
                    ? emp.roleName.map((rle, rleindx) => {
                        return rle.name[this.props.language.name];
                      })
                    : '---',
                  true,
                  ` ${centerClass}`,
                )}
                <div
                  className={`d-flex flex-column w-100 text-uppercase font-weight-bold text-third font-smaller px-1 ${centerClass} `}
                >
                  <div className="w-100 text-center">
                    <FormattedMessage id="profile.mobile" />
                  </div>

                  <div
                    style={{ direction: 'ltr' }}
                    className="w-100 text-uppercase font-smaller font-weight-bold text-white pt-2 justify-content-center d-flex"
                  >
                    {emp.basicInfo && emp.basicInfo.mobile}
                  </div>
                </div>
              </div>

              <div className="card-body d-flex flex-row pt-3 pb-0 px-0 w-100 justify-content-center align-items-center cursor-pointer">
                {this.renderDetailIcon(
                  'employee',
                  index,
                  emp,
                  'profilecredit.assigncredit',
                )}
              </div>
            </div>
          </div>
        </>
      ));
  };
  /* Render paging for employee grid */
  renderEmployeePaging = () => {
    const { employeeActivePage, employeeItemPerPage, totalEmployeeRecords } =
      this.state;

    return (
      <Pagination
        pageRangeDisplayed={5}
        linkClass="page-link"
        itemClass="page-item"
        innerClass="pagination directionInitial"
        activeClass="active"
        activePage={employeeActivePage}
        itemsCountPerPage={employeeItemPerPage}
        totalItemsCount={totalEmployeeRecords}
        onChange={(fun) => this.employeePageChange(fun)}
      />
    );
  };
  //Main render
  render() {
    return (
      <div
        className="py-2 col px-3 edit-business-profile-main-div h-100"
        style={{ minHeight: '100vh' }}
      >
        <div className={'d-flex my-3 justify-content-center text-white'}>
          <FormattedMessage id="profilecredit.creditmanagement" />
        </div>
        <div className="w-100 pb-3" id="accordion">
          <div
            className="w-100 mt-4"
            style={{
              // backgroundColor: "rgb(245, 245, 245)",
              border: '2px solid rgba(123,67,151)',
            }}
          >
            <div className="py-2 d-flex bg-primary" id="headingOne">
              <h5
                style={{ cursor: 'pointer' }}
                className={`d-flex w-75 align-items-center mb-0 px-3 text-white cursor-pointer text-uppercase font-weight-bold font-smaller justify-content-start`}
                data-toggle="collapse"
                data-target="#collapseOne"
                aria-expanded="true"
                aria-controls="collapseOne"
              >
                <FormattedMessage id="profilecredit.assigncredit" />

                <span className="px-2 font-smaller">
                  <ChevronDownIcon />
                </span>
              </h5>
            </div>
            <div
              id="collapseOne"
              className="collapse"
              aria-labelledby="headingOne"
              data-parent="#accordion"
            >
              <div className="card-body p-0">
                <div className="col-12 d-flex p-0 flex-column">
                  <div className="d-flex flex-column align-items-center justify-content-center mx-2 text-uppercase">
                    {this.showEmployeeList()}
                  </div>
                  <div className="d-flex justify-content-center pt-3 col-12">
                    {this.renderEmployeePaging()}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <form
          id="mobile-admin-credit-form"
          name="mobile-admin-credit-form"
          className=""
          onSubmit={this.doSubmit()}
        >
          {this.state.creditexpensesList.length > 0 && this.renderSearchPanle()}
        </form>
        {this.renderCreditList()}
        {this.renderPaging(this.state.creditListTotalCount)}
        {this.state.selectedEmp && (
          <>
            <div
              className="modal fade"
              data-backdrop="static"
              data-keyboard="false"
              id="employeeAllocationModal"
            ></div>
            {this.renderEmployeeAllocationModal()}
          </>
        )}
      </div>
    );
  }
}
//#endregion
function mapStateToProps(state, props) {
  return {
    language: state.language,
  };
}
export default injectIntl(
  connect(mapStateToProps, { changeLanguage })(withRouter(MobileAdminCredit)),
);
